function fillHotels(where, list) {
	let fillList;
	
	fillList = document.createElement('div')
	
	fillList.innerHTML = list
	where.appendChild(fillList)
}

export {fillHotels}